@charset "UTF-8";

/* src/app/components/shared/sidebar-summary-cart/sidebar-summary-cart.component.scss */
.color-header {
  color: var(--theme-sidebar-selected) !important;
}
.ds-summary-cart mat-datepicker-toggle button {
  position: absolute;
  left: -52px;
  bottom: 0px;
  opacity: 0;
}
.ds-summary-cart .mat-icon {
  color: rgba(0, 0, 0, 0.45) !important;
}
.ds-summary-cart {
  width: 100%;
  min-width: 320px;
  max-width: 404px;
}
.ds-summary-cart .ordersumary_heading {
  padding: 0px 16px;
}
.ds-summary-cart .md-3-line > .md-no-style:before,
.ds-summary-cart .md-3-line:before {
  min-height: 40px;
}
.ds-summary-cart .md-3-line,
.ds-summary-cart .md-3-line > .md-no-style {
  min-height: 40px;
}
.ds-summary-cart h3 {
  margin: 0 0 6px;
  line-height: 0.75em;
  font-size: 25px;
  font-weight: 600;
  color: #000000;
}
.ds-summary-cart p {
  margin: 0;
  line-height: 1.6em;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.01em;
  color: #000000;
}
.ds-summary-cart .md-secondary-container h3 {
  margin: 0 0 6px;
  line-height: 0.75em;
  font-size: 16px;
  font-weight: 600;
  color: #6a7379;
}
.ds-summary-cart .md-secondary-container p {
  margin: 0;
  line-height: 1.6em;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.01em;
}
.ds-summary-cart .mat-content {
  overflow: auto;
}
.ds-summary-cart .mat-content .list-item-head {
  margin-right: 0;
}
.ds-summary-cart .mat-content .list-item-head .md-3-line mat-icon {
  margin: 0 10px 0 0;
}
.ds-summary-cart .mat-content .list-item-head .total-coloumn h3 {
  margin: 0 0 6px;
  line-height: 0.75em;
  font-size: 16px;
  font-weight: 600;
}
.ds-summary-cart .mat-content .list-item-head .total-coloumn p {
  margin: 0;
  line-height: 1.6em;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.01em;
}
.ds-summary-cart .mat-content .mat-expansion-panel {
  box-shadow: none;
  padding-top: 10px;
}
.ds-summary-cart .mat-content .mat-expansion-panel .mat-expansion-panel-header {
  padding: 0px 0px 0px 24px;
  height: auto;
}
.ds-summary-cart .mat-content .mat-expansion-panel .mat-expansion-panel-body {
  padding: 0px 0px 16px 0px;
}
.ds-summary-cart .mat-content .mat-expansion-panel .panel1 .mat-expansion-indicator {
  margin-bottom: 25px;
  margin-right: 10px;
}
.ds-summary-cart .mat-content .mat-expansion-panel .panel2 .mat-expansion-indicator {
  margin-bottom: 180px;
  margin-right: 10px;
}
.ds-summary-cart .mat-content .list-item-head,
.ds-summary-cart .mat-content .items {
  padding: 0;
  min-height: auto;
}
.ds-summary-cart .mat-content .list-item-head .-text,
.ds-summary-cart .mat-content .items .-text {
  padding: 0;
}
.ds-summary-cart .mat-content .list-item-head .-text h3,
.ds-summary-cart .mat-content .items .-text h3 {
  color: var(--color1);
  font-weight: 600;
  font-size: 16px;
  margin: 0 0 6px;
  line-height: 0.75em;
}
.ds-summary-cart .mat-content .list-item-head .-text p,
.ds-summary-cart .mat-content .items .-text p {
  font-weight: 500;
  font-size: 14px;
  margin: 0;
  line-height: 1.6em;
}
.ds-summary-cart .mat-content .items {
  padding-left: 50px;
  padding-bottom: 15px;
  margin-top: 15px !important;
}
.ds-summary-cart .mat-content .items .cart-items__images {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 90px;
  height: 90px;
  overflow: hidden;
  margin-right: 15px;
  flex: 0 0 90px;
}
.ds-summary-cart .mat-content .items .cart-items__images img {
  border-radius: 0;
  width: 90px;
  height: auto;
  margin: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
}
.ds-summary-cart .mat-content .items .md-avatar:first-child,
.ds-summary-cart .mat-content .items .-inner > .md-avatar:first-child {
  border-radius: 0;
  width: 90px;
  height: 90px;
}
.ds-summary-cart .mat-content .items .md-secondary-container {
  top: 87%;
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.54);
  margin-bottom: 10px;
}
.ds-summary-cart .mat-content .items .input-group {
  width: 88px;
  line-height: 0;
}
.ds-summary-cart .mat-content .items .input-group .input-group-btn button {
  background: #fff;
  border: 1px solid #ccc;
  width: 30px;
  height: 30px;
  box-shadow: none;
  cursor: pointer;
}
.ds-summary-cart .mat-content .items .input-group .input-control {
  background: #fff;
  border: 1px solid #ccc;
  width: 30px;
  height: 28px;
  text-align: center;
  color: #1c7bbf;
}
.ds-summary-cart .mat-content .items .md-button.remove-items {
  position: absolute;
  top: -10px;
  right: 0;
}
.ds-summary-cart .mat-content .items mat-divider {
  left: 50px;
  bottom: -1px;
}
.ds-summary-cart .mat-content .view-more .md-subheader-inner {
  padding: 6px 0 0;
}
.ds-summary-cart .mat-content .view-more .md-subheader-inner h3 {
  text-align: center;
  margin: 0;
}
.ds-summary-cart .mat-content .items.total .right {
  text-align: right;
  padding-right: 15px;
  margin-right: 0;
  margin-top: 0;
}
.ds-summary-cart .mat-content .md-subheader-content {
  padding: 16px 16px 16px 0px;
}
.ds-summary-cart .mat-content .md-subheader-content .matDate {
  padding-left: 10px;
}
.ds-summary-cart .mat-content .md-subheader-content .matDate .autoShipFreq {
  text-align: center;
  font-size: 11px;
}
.ds-summary-cart .mat-content .md-subheader-content .initOrder h3 {
  color: var(--theme-sidebar-selected);
  font-size: 15px;
}
.ds-summary-cart .mat-content .md-subheader-content .pV {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5411764706);
}
.ds-summary-cart .mat-content .md-subheader-content .autoShipOrder {
  padding: 0px;
}
.ds-summary-cart .mat-content .md-subheader-content .autoShipH3 h3 {
  color: #EED620;
  font-size: 15px;
}
.ds-summary-cart .mat-content .md-subheader-content .subTotal {
  font-weight: 500;
  font-size: 14px;
  margin: 0;
  line-height: 1.6em;
  color: rgba(0, 0, 0, 0.5411764706);
}
.ds-summary-cart .mat-content .helper_text {
  background-color: #f6f6f6;
  text-align: center;
  padding: 10px;
  margin-bottom: 10px;
}
.ds-summary-cart .mat-content .mat-mdc-list-base {
  overflow-y: auto;
  height: 100vh;
}
.ds-summary-cart [ng-click] {
  cursor: pointer;
}
.ds-summary-cart .logButton {
  background-color: #000000;
  color: #FFFFFF;
  width: 80%;
  font-size: 14px;
  padding: 12px;
  text-align: center;
  border-radius: 40px;
}
.ds-summary-cart .checkOUTNewButton {
  background-color: #000000;
  color: #fff;
  min-width: 80%;
  max-width: 100%;
  font-size: 14px;
  padding: 12px;
  text-align: center;
  border-radius: 40px;
}
.ds-summary-cart .guestCheck {
  color: #2196F3;
  font-size: 14px;
}
.sidenavbar {
  position: fixed;
  height: 100vh;
  overflow-y: auto;
  width: 350px;
  right: -360px;
  margin-bottom: 50px;
  background-color: white;
  top: 0;
  z-index: 999;
  box-shadow: 0 15px 5px 0 rgba(77, 77, 77, 0.28);
  transition: all 0.5s ease;
}
.sidenavbar.show {
  right: -2px;
  -webkit-transition: max-height 0.25s ease-in;
  -moz-transition: max-height 0.25s ease-in;
  transition: all 0.5s ease;
}
.iconColor {
  color: rgba(0, 0, 0, 0.5411764706);
}
.m-0 {
  margin: 0 !important;
}
.m-t-0 {
  margin-top: 0 !important;
}
.m-b-0 {
  margin-bottom: 0 !important;
}
.m-l-0 {
  margin-left: 0 !important;
}
.m-r-0 {
  margin-right: 0 !important;
}
.m-5 {
  margin: 5px !important;
}
.m-t-5 {
  margin-top: 5px !important;
}
.m-b-5 {
  margin-bottom: 5px !important;
}
.m-l-5 {
  margin-left: 5px !important;
}
.m-r-5 {
  margin-right: 5px !important;
}
.m-l-7 {
  margin-left: 7px !important;
}
.m-10 {
  margin: 10px !important;
}
.m-t-10 {
  margin-top: 10px !important;
}
.m-b-10 {
  margin-bottom: 10px !important;
}
.m-l-10 {
  margin-left: 10px !important;
}
.m-r-10 {
  margin-right: 10px !important;
}
.m-15 {
  margin: 15px !important;
}
.m-t-13 {
  margin-top: 13px !important;
}
.m-t-15 {
  margin-top: 15px !important;
}
.m-b-15 {
  margin-bottom: 15px !important;
}
.m-l-15 {
  margin-left: 15px !important;
}
.m-l-10 {
  margin-left: 10px !important;
}
.m-r-15 {
  margin-right: 15px !important;
}
.m-20 {
  margin: 20px !important;
}
.m-t-20 {
  margin-top: 20px !important;
}
.m-b-20 {
  margin-bottom: 20px !important;
}
.m-l-20 {
  margin-left: 20px !important;
}
.m-r-20 {
  margin-right: 20px !important;
}
.m-25 {
  margin: 25px !important;
}
.m-t-25 {
  margin-top: 25px !important;
}
.m-b-25 {
  margin-bottom: 25px !important;
}
.m-l-25 {
  margin-left: 25px !important;
}
.m-r-25 {
  margin-right: 25px !important;
}
.m-30 {
  margin: 30px !important;
}
.m-t-30 {
  margin-top: 30px !important;
}
.m-b-30 {
  margin-bottom: 30px !important;
}
.m-l-30 {
  margin-left: 30px !important;
}
.m-r-30 {
  margin-right: 30px !important;
}
.p-0 {
  padding: 0 !important;
}
.p-t-0 {
  padding-top: 0 !important;
}
.p-b-0 {
  padding-bottom: 0 !important;
}
.p-l-0 {
  padding-left: 0 !important;
}
.p-r-0 {
  padding-right: 0 !important;
}
.p-5 {
  padding: 5px !important;
}
.p-t-5 {
  padding-top: 5px !important;
}
.p-b-5 {
  padding-bottom: 5px !important;
}
.p-l-5 {
  padding-left: 5px !important;
}
.p-r-5 {
  padding-right: 5px !important;
}
.p-10 {
  padding: 10px !important;
}
.p-t-10 {
  padding-top: 10px !important;
}
.p-t-8 {
  padding-top: 8px !important;
}
.p-b-10 {
  padding-bottom: 10px !important;
}
.p-l-10 {
  padding-left: 10px !important;
}
.p-r-10 {
  padding-right: 10px !important;
}
.p-15 {
  padding: 15px !important;
}
.p-t-15 {
  padding-top: 15px !important;
}
.p-b-15 {
  padding-bottom: 15px !important;
}
.p-l-15 {
  padding-left: 15px !important;
}
.p-r-15 {
  padding-right: 15px !important;
}
.p-20 {
  padding: 20px !important;
}
.p-t-20 {
  padding-top: 20px !important;
}
.p-b-20 {
  padding-bottom: 20px !important;
}
.p-l-20 {
  padding-left: 20px !important;
}
.p-r-20 {
  padding-right: 20px !important;
}
.p-25 {
  padding: 25px !important;
}
.p-t-25 {
  padding-top: 25px !important;
}
.p-b-25 {
  padding-bottom: 25px !important;
}
.p-l-25 {
  padding-left: 25px !important;
}
.p-r-25 {
  padding-right: 25px !important;
}
.p-30 {
  padding: 30px !important;
}
.p-t-30 {
  padding-top: 30px !important;
}
.p-b-30 {
  padding-bottom: 30px !important;
}
.p-l-30 {
  padding-left: 30px !important;
}
.p-r-30 {
  padding-right: 30px !important;
}
.f-300 {
  font-weight: 300 !important;
}
.f-400 {
  font-weight: 400 !important;
}
.f-500 {
  font-weight: 500 !important;
}
.f-700 {
  font-weight: 700 !important;
}
.p-relative {
  position: relative !important;
}
.p-absolute {
  position: absolute !important;
}
.p-fixed {
  position: fixed !important;
}
.p-static {
  position: static !important;
}
.o-hidden {
  overflow: hidden !important;
}
.o-visible {
  overflow: visible !important;
}
.o-auto {
  overflow: auto !important;
}
.d-block {
  display: block !important;
}
.di-block {
  display: inline-block !important;
}
.bgm-white {
  background-color: #fff !important;
}
.c-white {
  color: #fff !important;
}
.bgm-black {
  background-color: #000 !important;
}
.c-black {
  color: #000 !important;
}
.bgm-brown {
  background-color: #795548 !important;
}
.c-brown {
  color: #795548 !important;
}
.bgm-pink {
  background-color: #e91e63 !important;
}
.c-pink {
  color: #e91e63 !important;
}
.bgm-red {
  background-color: #f44336 !important;
}
.c-red {
  color: #f44336 !important;
}
.bgm-blue {
  background-color: #2196f3 !important;
}
.c-blue {
  color: #2196f3 !important;
}
.bgm-purple {
  background-color: #9c27b0 !important;
}
.c-purple {
  color: #9c27b0 !important;
}
.bgm-deeppurple {
  background-color: #673ab7 !important;
}
.c-deeppurple {
  color: #673ab7 !important;
}
.bgm-lightblue {
  background-color: #03a9f4 !important;
}
.c-lightblue {
  color: #03a9f4 !important;
}
.bgm-cyan {
  background-color: #00bcd4 !important;
}
.c-cyan {
  color: #00bcd4 !important;
}
.bgm-teal {
  background-color: #009688 !important;
}
.c-teal {
  color: #009688 !important;
}
.bgm-green {
  background-color: #4caf50 !important;
}
.c-green {
  color: #4caf50 !important;
}
.bgm-lightgreen {
  background-color: #8bc34a !important;
}
.c-lightgreen {
  color: #8bc34a !important;
}
.bgm-lime {
  background-color: #cddc39 !important;
}
.c-lime {
  color: #cddc39 !important;
}
.bgm-yellow {
  background-color: #ffeb3b !important;
}
.c-yellow {
  color: #ffeb3b !important;
}
.bgm-amber {
  background-color: #ffc107 !important;
}
.c-amber {
  color: #ffc107 !important;
}
.bgm-orange {
  background-color: #ff9800 !important;
}
.c-orange {
  color: #ff9800 !important;
}
.bgm-deeporange {
  background-color: #ff5722 !important;
}
.c-deeporange {
  color: #ff5722 !important;
}
.bgm-gray {
  background-color: #9e9e9e !important;
}
.c-gray {
  color: #9e9e9e !important;
}
.bgm-bluegray {
  background-color: #607d8b !important;
}
.c-bluegray {
  color: #607d8b !important;
}
.bgm-indigo {
  background-color: #3f51b5 !important;
}
.c-indigo {
  color: #3f51b5 !important;
}
.bg-black-trp {
  background-color: rgba(0, 0, 0, 0.1) !important;
}
.b-0 {
  border: 0 !important;
}
.w-100 {
  width: 100% !important;
}
.brd-2 {
  border-radius: 2px;
}
.t-uppercase {
  text-transform: uppercase;
}
.pad-right {
  padding-right: 4% !important;
}
.webalias-card {
  height: 290px !important;
}
.webalias-button {
  margin-top: 63px;
}
.b-b {
  border-bottom: 1px solid #e0e0e0 !important;
}
.border-top {
  border-top: 1px solid #e0e0e0 !important;
}
.f-s-15 {
  font-size: 15px !important;
}
.f-s-12 {
  font-size: 12px !important;
}
.p-t-50 {
  padding-top: 50px;
}
.cursor-pointer {
  cursor: pointer;
}
.b-full {
  border: 1px solid #e0e0e0;
}
.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  border-top-color: #f0f0f0;
  border-top-style: solid;
  border-top-width: 1px;
  line-height: 1.42857;
  padding-bottom: 13px;
  padding-right: 13px;
  padding-top: 13px;
  vertical-align: top;
}
.m-t--10 {
  margin-top: -10px !important;
}
.fadeMe {
  width: 100% !important;
  height: 100% !important;
  z-index: 99999999 !important;
  top: 0 !important;
  left: 0 !important;
  position: fixed !important;
}
.b-r {
  border-right: 1px solid #ccc;
}
.b-l {
  border-right: 1px solid #ccc;
}
.b-t {
  border-right: 1px solid #ccc;
}
.min-h-230 {
  min-height: 230px;
}
.t-view[data-tv-type=text]:before {
  content: "\f24f";
  background: #00bcd4;
  box-shadow: 0 0 0 1px #00bcd4;
}
.t-view[data-tv-type=text]:after {
  background: #00bcd4;
}
.t-view[data-tv-type=image]:before {
  content: "\f17f";
  background: #4caf50;
  box-shadow: 0 0 0 1px #4caf50;
}
.t-view[data-tv-type=image]:after {
  background: #4caf50;
}
.t-view[data-tv-type=video]:before {
  content: "\f3a9";
  background: #ffc107;
  box-shadow: 0 0 0 1px #ffc107;
}
.t-view[data-tv-type=video]:after {
  background: #ffc107;
}
.t-view .tvb-stats {
  list-style: none;
  padding: 0;
  margin: 10px 0 20px;
}
.t-view .tvb-stats > li {
  display: inline-block;
  padding: 5px 10px 6px;
  border: 1px solid #ccc;
  margin-right: 2px;
}
.t-view .tvb-stats > li i {
  font-size: 15px;
  line-height: 100%;
  vertical-align: top;
  margin-top: 2px;
}
.t-view .tvb-stats > li.tvbs-comments {
  border-color: #4caf50;
  color: #4caf50;
}
.t-view .tvb-stats > li.tvbs-likes {
  border-color: #03a9f4;
  color: #03a9f4;
}
.t-view .tvb-stats > li.tvbs-views {
  border-color: #ff9800;
  color: #ff9800;
}
.tv-comments .tvc-lists {
  padding: 0;
  list-style: none;
  margin: 0;
}
.tv-comments .tvc-lists > li {
  padding: 15px 20px;
  margin: 0;
  border-top: 1px solid #eee;
}
.tvc-more {
  color: #333;
  display: block;
  margin-bottom: -10px;
}
.tvc-more:hover {
  color: #000;
}
.tvc-more i {
  vertical-align: middle;
  margin-right: 5px;
}
.p-header {
  position: relative;
  margin: 0 -7px;
}
.p-header .actions {
  position: absolute;
  top: -18px;
  right: 0;
}
.p-menu {
  list-style: none;
  padding: 0 5px;
  margin: 0 0 30px;
}
.p-menu > li {
  display: inline-block;
  vertical-align: top;
}
.p-menu > li > a {
  display: block;
  padding: 5px 20px 5px 0;
  font-weight: 500;
  text-transform: uppercase;
  font-size: 15px;
}
.p-menu > li > a > i {
  margin-right: 4px;
  font-size: 20px;
  vertical-align: middle;
  margin-top: -5px;
}
.p-menu > li:not(.active) > a {
  color: #4285F4;
}
.p-menu > li:not(.active) > a:hover {
  color: #333;
}
.p-menu > li.active > a {
  color: #000;
}
@media (max-width: 991px) {
  .p-menu .pm-search {
    margin: 20px 2px 30px;
    display: block;
  }
  .p-menu .pm-search input[type=text] {
    width: 100%;
    border: 1px solid #ccc;
  }
}
.p-menu .pms-inner {
  margin: -2px 0 0;
  position: relative;
  top: -2px;
  overflow: hidden;
  white-space: nowrap;
}
.p-menu .pms-inner i {
  vertical-align: top;
  font-size: 20px;
  line-height: 100%;
  position: absolute;
  left: 9px;
  top: 8px;
  color: #333;
}
.p-menu .pms-inner input[type=text] {
  height: 35px;
  border-radius: 2px;
  padding: 0 10px 0 40px;
}
@media (min-width: 768px) {
  .p-menu .pms-inner input[type=text] {
    border: 1px solid #fff;
    width: 50px;
    background: transparent;
    position: relative;
    z-index: 1;
    transition: all;
    transition-duration: 300ms;
  }
  .p-menu .pms-inner input[type=text]:focus {
    border-color: #DFDFDF;
    width: 200px;
  }
}
.photos {
  margin: -3px 0 0;
}
.photos .lightbox {
  margin: 0 -8px;
}
.photos:not(.p-timeline)[data-src] {
  padding: 3px;
  transition: all;
  transition-duration: 150ms;
}
.p-grid {
  list-style: none;
  padding: 0;
  margin: 0 0 23px;
  text-align: center;
}
.p-grid > li {
  display: inline-block;
  vertical-align: top;
  width: 30px;
  height: 30px;
  border: 1px solid #D5D5D5;
  line-height: 27px;
  font-size: 12px;
  color: #ABABAB;
  border-radius: 50%;
  cursor: pointer;
  letter-spacing: -1px;
  padding-right: 1px;
  margin: 0 2px;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.p-grid > li:hover {
  border-color: silver;
}
.p-grid > li.active {
  color: #8C8C8C;
  border-color: #8C8C8C;
}
.p-timeline {
  position: relative;
  padding-left: 80px;
  margin-bottom: 75px;
}
.p-timeline[data-src] {
  float: left;
  width: 70px;
  height: 70px;
  margin: 0 3px 3px 0;
}
.contacts:not(.c-profile) {
  padding: 0 8px;
}
.contacts > [class*=col-] {
  padding: 0 10px;
}
.contacts .c-item {
  border: 1px solid #e2e2e2;
  border-radius: 2px;
  margin-bottom: 24px;
}
.contacts .c-item .ci-avatar {
  display: block;
}
.contacts .c-item .ci-avatar img {
  width: 100%;
  border-radius: 2px 2px 0 0;
}
.contacts .ci-avatar {
  margin: -1px -1px 0;
}
.contacts .c-info {
  text-align: center;
  margin-top: 15px;
  padding: 0 5px;
}
.contacts .c-info strong {
  color: #000;
  font-size: 14px;
  font-weight: 500;
}
.contacts .c-info small {
  color: #999;
  margin-top: 3px;
}
.contacts .c-info strong,
.contacts .c-info small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}
.contacts .c-footer {
  border-top: 1px solid #e2e2e2;
  margin-top: 18px;
}
.contacts .c-footer > button {
  padding: 4px 10px 3px;
  display: block;
  width: 100%;
  text-align: center;
  color: #333;
  font-weight: 500;
  border-radius: 2px;
  background: #fff;
  border: 0;
}
.contacts .c-footer > button > i {
  font-size: 16px;
  vertical-align: middle;
  margin-top: -3px;
}
.z-depth-1 {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.16), 0 2px 10px rgba(0, 0, 0, 0.12) !important;
}
.z-depth-1-top {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);
}
.z-depth-1-bottom {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.16);
}
.z-depth-2 {
  box-shadow: 0 8px 17px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.19);
}
.z-depth-2-top {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.19);
}
.z-depth-2-bottom {
  box-shadow: 0 8px 17px rgba(0, 0, 0, 0.2);
}
.z-depth-3 {
  box-shadow: 0 12px 15px rgba(0, 0, 0, 0.24), 0 17px 50px rgba(0, 0, 0, 0.19);
}
.z-depth-3-top {
  box-shadow: 0 17px 50px rgba(0, 0, 0, 0.19);
}
.z-depth-3-bottom {
  box-shadow: 0 12px 15px rgba(0, 0, 0, 0.24);
}
.z-depth-4 {
  box-shadow: 0 16px 28px rgba(0, 0, 0, 0.22), 0 25px 55px rgba(0, 0, 0, 0.21);
}
.z-depth-4-top {
  box-shadow: 0 25px 55px rgba(0, 0, 0, 0.21);
}
.z-depth-4-bottom {
  box-shadow: 0 16px 28px rgba(0, 0, 0, 0.22);
}
.z-depth-5 {
  box-shadow: 0 27px 24px rgba(0, 0, 0, 0.2), 0 40px 77px rgba(0, 0, 0, 0.22);
}
.z-depth-5-top {
  box-shadow: 0 40px 77px rgba(0, 0, 0, 0.22);
}
.z-depth-5-bottom {
  box-shadow: 0 27px 24px rgba(0, 0, 0, 0.2);
}
.z-depth-animation .z-depth-1,
.z-depth-animation .z-depth-2,
.z-depth-animation .z-depth-3,
.z-depth-animation .z-depth-4,
.z-depth-animation .z-depth-5 {
  transition: box-shadow 0.28s cubic-bezier(0.4, 0, 0.2, 1);
}
.block-header {
  margin-bottom: 25px;
  position: relative;
}
@media screen and (min-width: 768px) {
  .block-header {
    padding: 0 22px;
  }
}
@media screen and (max-width: 991px) {
  .block-header {
    padding: 0 18px;
  }
}
.block-header > h2 {
  font-size: 15px;
  color: #777;
  margin: 0;
  font-weight: 400;
  text-transform: uppercase;
}
.block-header > h2 > small {
  display: block;
  text-transform: none;
  margin-top: 8px;
  margin-bottom: 20px;
  color: #9E9E9E;
  line-height: 140%;
}
.block-header .actions {
  position: absolute;
  right: 10px;
  top: -5px;
  z-index: 5;
}
.block-header-alt h1,
.block-header-alt h2,
.block-header-alt h3,
.block-header-alt h4,
.block-header-alt h5 {
  color: #575757;
  font-weight: 100;
}
.actions {
  list-style: none;
  padding: 0;
  z-index: 2;
  margin: 0;
}
.actions > li {
  display: inline-block;
  vertical-align: baseline;
}
.actions > li > a,
.actions > a {
  width: 30px;
  height: 30px;
  line-height: 35px;
  display: inline-block;
  text-align: center;
  position: relative;
}
.actions > li > a > i,
.actions > a > i {
  transition: color;
  transition-duration: 1300ms;
  color: #adadad;
  font-size: 20px;
}
.actions > li > a:hover > i,
.actions > a:hover > i {
  color: #000;
}
.actions > li > a:before,
.actions > a:before {
  left: 0;
  top: 0;
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-transform: scale3d(0, 0, 0);
  transform: scale3d(0, 0, 0);
  transition: all;
  transition-duration: 250ms;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 0;
  border-radius: 50%;
  opacity: 0;
  filter: alpha(opacity=0);
}
.actions > li > a:hover:before,
.actions > a:hover:before {
  -webkit-transform: scale3d(1, 1, 1);
  transform: scale3d(1, 1, 1);
  opacity: 1;
  filter: alpha(opacity=100);
}
.actions > li.open > a > i,
.actions.open > a > i {
  color: #000;
}
.actions > li.open > a:before,
.actions.open > a:before {
  -webkit-transform: scale(1);
  transform: scale(1);
  opacity: 1;
  filter: alpha(opacity=100);
}
.actions.actions-alt > li > a > i {
  color: #fff;
}
.actions.actions-alt > li > a > i:hover {
  color: #fff;
}
.actions.actions-alt > li.open > a > i {
  color: #fff;
}
.actions.open {
  z-index: 3;
}
.load-more {
  text-align: center;
  margin-top: 30px;
}
.load-more a {
  padding: 5px 10px 4px;
  display: inline-block;
  background-color: #f44336;
  color: #FFF;
  border-radius: 2px;
  white-space: nowrap;
}
.load-more a i {
  font-size: 20px;
  vertical-align: middle;
  position: relative;
  margin-right: 5px;
}
.load-more a:hover {
  background-color: #ea1c0d;
}
.a-title {
  color: #333;
  font-weight: 500;
}
.a-title:hover {
  color: #333;
  text-decoration: underline;
}
.container-alt {
  max-width: 1170px;
}
.ie-warning {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  background: #000;
  width: 100%;
  height: 100%;
  text-align: center;
  color: #fff;
  font-family:
    "Courier New",
    Courier,
    monospace;
  padding: 50px 0;
}
.ie-warning p {
  font-size: 17px;
}
.ie-warning .iew-container {
  min-width: 1024px;
  width: 100%;
  height: 200px;
  background: #fff;
  margin: 50px 0;
}
.ie-warning .iew-download {
  list-style: none;
  padding: 30px 0;
  margin: 0 auto;
  width: 720px;
}
.ie-warning .iew-download > li {
  float: left;
  vertical-align: top;
}
.ie-warning .iew-download > li > a {
  display: block;
  color: #000;
  width: 140px;
  font-size: 15px;
  padding: 15px 0;
}
.ie-warning .iew-download > li > a > div {
  margin-top: 10px;
}
.ie-warning .iew-download > li > a:hover {
  background-color: #eee;
}
#footer .f-menu {
  display: block;
  width: 100%;
  padding-left: 0;
  list-style: none;
  margin-left: -5px;
  margin-top: 8px;
}
#footer .f-menu > li {
  display: inline-block;
  padding-left: 5px;
  padding-right: 5px;
}
#footer .f-menu > li > a {
  color: #a2a2a2;
}
#footer .f-menu > li > a:hover {
  color: #777;
}
.pricing-table {
  max-width: 1170px;
  margin: 70px auto 0;
}
.invoice {
  max-width: 1170px;
}
.i-logo {
  width: 150px;
}
.i-table .highlight {
  background-color: #eee;
  border-bottom: 1px solid #e6e6e6;
}
.i-table td.highlight {
  font-size: 14px;
  font-weight: 500;
}
.wall {
  max-width: 1000px;
}
@media (min-width: 768px) and (max-width: 991px) {
  .wall {
    width: 600px;
  }
}
.wall-attrs {
  margin-bottom: 0;
}
.wa-stats {
  float: left;
}
.wa-stats > span {
  margin-right: -1px;
  padding: 7px 12px;
  border: 1px solid #cfcfcf;
  float: left;
  font-weight: 500;
}
.wa-stats > span.active {
  color: #4caf50;
}
.wa-stats > span:first-child {
  border-radius: 2px 0 0 2px;
}
.wa-stats > span:last-child {
  border-radius: 0 2px 2px 0;
}
.wa-stats > span > i {
  line-height: 100%;
  vertical-align: top;
  position: relative;
  top: 2px;
  font-size: 15px;
  margin-right: 2px;
}
.wa-users {
  float: right;
  padding: 0 !important;
  margin-right: -5px;
}
.wa-users > a {
  display: inline-block;
  margin-left: 2px;
}
.wa-users > a > img {
  width: 33px;
  height: 33px;
  border-radius: 50%;
}
.wa-users > a > img:hover {
  opacity: 0.85;
  filter: alpha(opacity=85);
}
.wcc-inner {
  resize: none;
  border-radius: 2px;
  background: #fff;
  color: #9A9A9A;
  cursor: pointer;
  position: relative;
}
.wcci-text {
  border: 1px solid #E4E4E4;
  display: block;
  width: 100%;
  resize: none;
  padding: 10px 15px;
}
.wcc-text-icon {
  position: absolute;
  right: 0;
  top: 2px;
}
.wall-comment-list {
  padding: 20px;
  background: #f7f7f7;
}
.wall-comment-list .media {
  position: relative;
}
.wall-comment-list .media:hover .actions {
  display: block;
}
.wall-comment-list .actions {
  display: none;
  position: absolute;
  right: -20px;
  top: -1px;
}
.wcl-list + .wcl-form {
  margin-top: 25px;
}
.wp-text {
  border: 0;
  padding: 0;
  display: block;
  width: 100%;
  resize: none;
}
.wp-media {
  background: #f7f7f7;
  border: 1px solid #E4E4E4;
  padding: 12px 15px;
  margin-top: 25px;
  text-align: center;
}
.wpb-actions {
  background: #f7f7f7;
  margin: 0;
  padding: 10px 20px;
}
.wpb-actions > li:not(.pull-right) {
  float: left;
}
[data-wpba=image] {
  color: #4caf50;
}
[data-wpba=image]:hover {
  color: #449d48;
}
[data-wpba=video] {
  color: #ff9800;
}
[data-wpba=video]:hover {
  color: #e68900;
}
[data-wpba=link] {
  color: #00bcd4;
}
[data-wpba=link]:hover {
  color: #00a5bb;
}
.wpba-attrs > ul > li {
  padding: 0;
  margin-right: 5px;
}
.wpba-attrs > ul > li > a {
  display: block;
  width: 22px;
}
.wpba-attrs > ul > li > a > i {
  font-size: 20px;
}
.wpba-attrs > ul > li > a.active > i {
  color: #333;
}
.wall-img-preview {
  text-align: center;
}
@media screen and (min-width: 768px) {
  .wall-img-preview {
    margin: 0 -23px 20px;
  }
}
@media screen and (max-width: 991px) {
  .wall-img-preview {
    margin: 0 -16px 20px;
  }
}
.wall-img-preview .wip-item {
  display: block;
  float: left;
  position: relative;
  overflow: hidden;
  border: 2px solid #fff;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.wall-img-preview .wip-item > img {
  display: none;
}
.wall-img-preview .wip-item:first-child:nth-last-child(2),
.wall-img-preview .wip-item:first-child:nth-last-child(2) ~ div {
  width: 50%;
  padding-bottom: 40%;
}
.wall-img-preview .wip-item:first-child:nth-last-child(3),
.wall-img-preview .wip-item:first-child:nth-last-child(3) ~ div,
.wall-img-preview .wip-item:first-child:nth-last-child(4),
.wall-img-preview .wip-item:first-child:nth-last-child(4) ~ div:not(:last-child),
.wall-img-preview .wip-item:first-child:nth-last-child(5),
.wall-img-preview .wip-item:first-child:nth-last-child(5) ~ div:not(:nth-last-of-type(-n+2)),
.wall-img-preview .wip-item:first-child:nth-last-child(6),
.wall-img-preview .wip-item:first-child:nth-last-child(6) ~ div,
.wall-img-preview .wip-item:first-child:nth-last-child(7) ~ div:nth-last-of-type(-n+3) {
  width: 33.333333%;
  padding-bottom: 30%;
}
.wall-img-preview .wip-item:first-child:nth-last-child(5) ~ div:nth-last-of-type(-n+2) {
  width: 50%;
  padding-bottom: 40%;
}
.wall-img-preview .wip-item:first-child:nth-last-child(7),
.wall-img-preview .wip-item:first-child:nth-last-child(7) ~ div:not(:nth-last-of-type(-n+3)),
.wall-img-preview .wip-item:first-child:nth-last-child(n+8),
.wall-img-preview .wip-item:first-child:nth-last-child(n+8) ~ div {
  width: 25%;
  padding-bottom: 22%;
}
.wall-img-preview .wip-item:only-child,
.wall-img-preview .wip-item:first-child:nth-last-child(4) ~ div:nth-child(4) {
  width: 100%;
  padding-bottom: 50%;
}
@media print {
  @page {
    margin: 0;
    size: auto;
  }
  body {
    margin: 0 !important;
    padding: 0 !important;
  }
  #header,
  #footer,
  #sidebar,
  #chat,
  .growl-animated,
  .m-btn {
    display: none !important;
  }
  .invoice {
    padding: 30px !important;
    -webkit-print-color-adjust: exact !important;
  }
  .invoice .card-header {
    background: #eee !important;
    padding: 20px;
    margin: -60px -30px 25px;
  }
  .invoice .block-header {
    display: none;
  }
  .invoice .highlight {
    background: #eee !important;
  }
}
#calendar-widget {
  margin-bottom: 30px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.15);
}
#fc-actions {
  position: absolute;
  bottom: 10px;
  right: 12px;
}
.fc {
  background-color: #fff;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.15);
  margin-bottom: 30px;
}
.fc td,
.fc th {
  border-color: #cfcfcf;
}
.fc th {
  font-weight: 400;
}
#calendar-widget .fc-toolbar {
  background: #009688;
}
#calendar-widget .fc-day-header {
  color: #fff;
  background: #007d71;
  padding: 5px 0;
  border-width: 0;
}
#calendar-widget .fc-day-number {
  text-align: center;
  color: #ADADAD;
  padding: 5px 0;
}
#calendar-widget .fc-day-grid-event {
  margin: 1px 3px;
}
#calendar-widget .ui-widget-header th,
#calendar-widget .ui-widget-header {
  border-width: 0;
}
#calendar .fc-toolbar:before {
  content: "";
  height: 50px;
  width: 100%;
  background: rgba(0, 0, 0, 0.36);
  position: absolute;
  bottom: 0;
  left: 0;
}
#calendar .fc-toolbar .fc-center {
  margin-top: 238px;
  position: relative;
}
@media screen and (max-width: 991px) {
  #calendar .fc-toolbar {
    height: 200px;
  }
  #calendar .fc-toolbar .fc-center {
    margin-top: 138px;
  }
}
#calendar .fc-day-header {
  color: #ADADAD;
  text-align: left;
  font-size: 14px;
  border-bottom-width: 0;
  border-right-color: #cfcfcf;
  padding: 10px 12px;
}
#calendar .fc-day-number {
  padding-left: 10px !important;
  color: #CCC;
  text-align: left !important;
}
@media screen and (min-width: 991px) {
  #calendar .fc-day-number {
    font-size: 25px;
    letter-spacing: -2px;
  }
}
#calendar .fc-day-grid-event {
  margin: 1px 9px 0;
}
.fc-today {
  color: #ffc107;
}
.fc-toolbar {
  margin-bottom: 0;
  padding: 20px 7px 19px;
  position: relative;
}
.fc-toolbar h2 {
  margin-top: 7px;
  font-size: 20px;
  font-weight: 400;
  text-transform: uppercase;
  color: #fff;
}
.fc-toolbar .ui-button {
  border: 0;
  background: 0 0;
  padding: 0;
  outline: none !important;
  text-align: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-top: 2px;
  color: #fff;
}
.fc-toolbar .ui-button:hover {
  background: #fff;
  color: #009688;
}
.fc-toolbar .ui-button > span {
  position: relative;
  font-family: "Material-Design-Iconic-Font";
  font-size: 20px;
  line-height: 100%;
  width: 30px;
  display: block;
  margin-top: 2px;
}
.fc-toolbar .ui-button > span:before {
  position: relative;
  z-index: 1;
}
.fc-toolbar .ui-button > span.ui-icon-circle-triangle-w:before {
  content: "\f2fa";
}
.fc-toolbar .ui-button > span.ui-icon-circle-triangle-e:before {
  content: "\f2fb";
}
.fc-event {
  padding: 0;
  font-size: 11px;
  border-radius: 0;
  border: 0;
}
.fc-event .fc-title {
  padding: 2px 8px;
  display: block;
}
.fc-event .fc-time {
  float: left;
  background: rgba(0, 0, 0, 0.2);
  padding: 2px 6px;
  margin: 0 0 0 -1px;
}
.fc-view,
.fc-view > table {
  border: 0;
}
.fc-view > table > tbody > tr > .ui-widget-content {
  border-top: 0;
}
div.fc-row {
  margin-right: 0 !important;
  border: 0 !important;
}
.event-tag {
  margin-top: 5px;
}
.event-tag > span {
  border-radius: 50%;
  width: 30px;
  height: 30px;
  margin-right: 3px;
  position: relative;
  display: inline-block;
  cursor: pointer;
}
.event-tag > span:hover {
  opacity: 0.8;
  filter: alpha(opacity=80);
}
.event-tag > span.selected:before {
  font-family: "Material-Design-Iconic-Font";
  content: "\f26b";
  position: absolute;
  text-align: center;
  top: 3px;
  width: 100%;
  font-size: 17px;
  color: #FFF;
}
hr.fc-divider {
  border-width: 1px;
  border-color: #eee;
}
.fc-day-grid-container.fc-scroller {
  height: auto !important;
  overflow: hidden !important;
}
.noUi-target {
  border-radius: 0;
  box-shadow: none;
  border: 0;
}
.noUi-background {
  background: #d4d4d4;
  box-shadow: none;
}
.noUi-horizontal {
  height: 3px;
}
.noUi-horizontal .noUi-handle {
  top: -8px;
}
.noUi-vertical {
  width: 3px;
}
.noUi-horizontal .noUi-handle,
.noUi-vertical .noUi-handle {
  width: 19px;
  height: 19px;
  border: 0;
  border-radius: 100%;
  box-shadow: none;
  transition: box-shadow;
  transition-duration: 200ms;
  cursor: pointer;
  position: relative;
}
.noUi-horizontal .noUi-handle:before,
.noUi-vertical .noUi-handle:before,
.noUi-horizontal .noUi-handle:after,
.noUi-vertical .noUi-handle:after {
  display: none;
}
.noUi-horizontal .noUi-handle:active,
.noUi-vertical .noUi-handle:active {
  background: #ccc !important;
}
.noUi-horizontal .noUi-handle .is-tooltip,
.noUi-vertical .noUi-handle .is-tooltip {
  position: absolute;
  bottom: 32px;
  height: 35px;
  border-radius: 2px;
  color: #fff;
  text-align: center;
  line-height: 33px;
  width: 50px;
  left: 50%;
  margin-left: -25px;
  padding: 0 10px;
  transition: all;
  transition-duration: 200ms;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  opacity: 0;
  filter: alpha(opacity=0);
  -webkit-transform: scale(0);
  transform: scale(0);
}
.noUi-horizontal .noUi-handle .is-tooltip:after,
.noUi-vertical .noUi-handle .is-tooltip:after {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 15px 10px 0;
  position: absolute;
  bottom: -8px;
  left: 50%;
  margin-left: -9px;
  content: "";
}
.noUi-horizontal .noUi-active,
.noUi-vertical .noUi-active {
  box-shadow: 0 0 0 13px rgba(0, 0, 0, 0.1);
}
.noUi-horizontal .noUi-active .is-tooltip,
.noUi-vertical .noUi-active .is-tooltip {
  -webkit-transform: scale(1);
  transform: scale(1);
  bottom: 40px;
  opacity: 1;
  filter: alpha(opacity=100);
}
.input-slider:not([data-is-color]) .noUi-handle,
.input-slider-range:not([data-is-color]) .noUi-handle,
.input-slider-values:not([data-is-color]) .noUi-handle,
.input-slider:not([data-is-color]) .noUi-connect,
.input-slider-range:not([data-is-color]) .noUi-connect,
.input-slider-values:not([data-is-color]) .noUi-connect {
  background: #009688 !important;
}
.input-slider:not([data-is-color]) .is-tooltip,
.input-slider-range:not([data-is-color]) .is-tooltip,
.input-slider-values:not([data-is-color]) .is-tooltip {
  background: #009688;
}
.input-slider:not([data-is-color]) .is-tooltip:after,
.input-slider-range:not([data-is-color]) .is-tooltip:after,
.input-slider-values:not([data-is-color]) .is-tooltip:after {
  border-color: #009688 transparent transparent;
}
.input-slider[data-is-color=red] .noUi-handle,
.input-slider-range[data-is-color=red] .noUi-handle,
.input-slider-values[data-is-color=red] .noUi-handle,
.input-slider[data-is-color=red] .noUi-connect,
.input-slider-range[data-is-color=red] .noUi-connect,
.input-slider-values[data-is-color=red] .noUi-connect {
  background: #f44336 !important;
}
.input-slider[data-is-color=blue] .noUi-handle,
.input-slider-range[data-is-color=blue] .noUi-handle,
.input-slider-values[data-is-color=blue] .noUi-handle,
.input-slider[data-is-color=blue] .noUi-connect,
.input-slider-range[data-is-color=blue] .noUi-connect,
.input-slider-values[data-is-color=blue] .noUi-connect {
  background: #2196f3 !important;
}
.input-slider[data-is-color=cyan] .noUi-handle,
.input-slider-range[data-is-color=cyan] .noUi-handle,
.input-slider-values[data-is-color=cyan] .noUi-handle,
.input-slider[data-is-color=cyan] .noUi-connect,
.input-slider-range[data-is-color=cyan] .noUi-connect,
.input-slider-values[data-is-color=cyan] .noUi-connect {
  background: #00bcd4 !important;
}
.input-slider[data-is-color=amber] .noUi-handle,
.input-slider-range[data-is-color=amber] .noUi-handle,
.input-slider-values[data-is-color=amber] .noUi-handle,
.input-slider[data-is-color=amber] .noUi-connect,
.input-slider-range[data-is-color=amber] .noUi-connect,
.input-slider-values[data-is-color=amber] .noUi-connect {
  background: #ffc107 !important;
}
.input-slider[data-is-color=green] .noUi-handle,
.input-slider-range[data-is-color=green] .noUi-handle,
.input-slider-values[data-is-color=green] .noUi-handle,
.input-slider[data-is-color=green] .noUi-connect,
.input-slider-range[data-is-color=green] .noUi-connect,
.input-slider-values[data-is-color=green] .noUi-connect {
  background: #4caf50 !important;
}
.input-slider .noUi-origin {
  background: #d4d4d4;
}
.input-slider:not([data-is-color]) .noUi-base {
  background: #009688 !important;
}
.input-slider[data-is-color=red] .noUi-base {
  background: #f44336 !important;
}
.input-slider[data-is-color=blue] .noUi-base {
  background: #2196f3 !important;
}
.input-slider[data-is-color=cyan] .noUi-base {
  background: #00bcd4 !important;
}
.input-slider[data-is-color=amber] .noUi-base {
  background: #ffc107 !important;
}
.input-slider[data-is-color=green] .noUi-base {
  background: #4caf50 !important;
}
.cp-container {
  position: relative;
}
.cp-container > .input-group input.cp-value {
  color: #000 !important;
  background: transparent !important;
}
.cp-container > .input-group .dropdown-menu {
  padding: 20px;
}
.cp-container i.cp-value {
  width: 25px;
  height: 25px;
  border-radius: 2px;
  position: absolute;
  top: 0;
  right: 15px;
}
.note-editor,
.note-popover {
  border-color: #e4e4e4;
}
.note-editor .note-toolbar,
.note-popover .note-toolbar,
.note-editor .popover-content,
.note-popover .popover-content {
  background: #fff;
  border-color: #e4e4e4;
  margin: 0;
  padding: 10px 0 15px;
  text-align: center;
}
.note-editor .note-toolbar > .btn-group,
.note-popover .note-toolbar > .btn-group,
.note-editor .popover-content > .btn-group,
.note-popover .popover-content > .btn-group {
  display: inline-block;
  float: none;
  box-shadow: none;
}
.note-editor .note-toolbar > .btn-group .btn,
.note-popover .note-toolbar > .btn-group .btn,
.note-editor .popover-content > .btn-group .btn,
.note-popover .popover-content > .btn-group .btn {
  margin: 0 1px;
}
.note-editor .note-toolbar > .btn-group > .active,
.note-popover .note-toolbar > .btn-group > .active,
.note-editor .popover-content > .btn-group > .active,
.note-popover .popover-content > .btn-group > .active {
  background: #00bcd4;
  color: #fff;
}
.note-editor .note-toolbar .btn,
.note-popover .note-toolbar .btn,
.note-editor .popover-content .btn,
.note-popover .popover-content .btn {
  height: 40px;
  border-radius: 2px !important;
  box-shadow: none !important;
}
.note-editor .note-toolbar .btn:active,
.note-popover .note-toolbar .btn:active,
.note-editor .popover-content .btn:active,
.note-popover .popover-content .btn:active {
  box-shadow: none;
}
.note-editor .note-toolbar .note-palette-title,
.note-popover .note-toolbar .note-palette-title,
.note-editor .popover-content .note-palette-title,
.note-popover .popover-content .note-palette-title {
  margin: 0 !important;
  padding: 10px 0 !important;
  font-size: 13px !important;
  text-align: center !important;
  border: 0 !important;
}
.note-editor .note-toolbar .note-color-reset,
.note-popover .note-toolbar .note-color-reset,
.note-editor .popover-content .note-color-reset,
.note-popover .popover-content .note-color-reset {
  padding: 0 0 10px !important;
  margin: 0 !important;
  background: none;
  text-align: center;
}
.note-editor .note-toolbar .note-color .dropdown-menu,
.note-popover .note-toolbar .note-color .dropdown-menu,
.note-editor .popover-content .note-color .dropdown-menu,
.note-popover .popover-content .note-color .dropdown-menu {
  min-width: 335px;
}
.note-editor .note-statusbar .note-resizebar,
.note-popover .note-statusbar .note-resizebar {
  border-color: #E8E8E8;
}
.note-editor .note-statusbar .note-resizebar .note-icon-bar,
.note-popover .note-statusbar .note-resizebar .note-icon-bar {
  border-color: #BCBCBC;
}
.note-editor .fa,
.note-popover .fa {
  font-style: normal;
  font-size: 20px;
  vertical-align: middle;
}
.note-editor .fa:before,
.note-popover .fa:before {
  font-family: "Material Design Iconic Font";
}
.note-editor .fa.fa-magic:before,
.note-popover .fa.fa-magic:before {
  content: "\f11b";
}
.note-editor .fa.fa-bold:before,
.note-popover .fa.fa-bold:before {
  content: "\f17a";
}
.note-editor .fa.fa-italic:before,
.note-popover .fa.fa-italic:before {
  content: "\f181";
}
.note-editor .fa.fa-underline:before,
.note-popover .fa.fa-underline:before {
  content: "\f18b";
}
.note-editor .fa.fa-font:before,
.note-popover .fa.fa-font:before {
  content: "\f17e";
}
.note-editor .fa.fa-list-ul:before,
.note-popover .fa.fa-list-ul:before {
  content: "\f183";
}
.note-editor .fa.fa-list-ol:before,
.note-popover .fa.fa-list-ol:before {
  content: "\f184";
}
.note-editor .fa.fa-align-left:before,
.note-popover .fa.fa-align-left:before {
  content: "\f178";
  content: "\f178";
}
.note-editor .fa.fa-align-right:before,
.note-popover .fa.fa-align-right:before {
  content: "\f179";
}
.note-editor .fa.fa-align-center:before,
.note-popover .fa.fa-align-center:before {
  content: "\f176";
}
.note-editor .fa.fa-align-justify:before,
.note-popover .fa.fa-align-justify:before {
  content: "\f177";
}
.note-editor .fa.fa-indent:before,
.note-popover .fa.fa-indent:before {
  content: "\f180";
}
.note-editor .fa.fa-outdent:before,
.note-popover .fa.fa-outdent:before {
  content: "\f17f";
}
.note-editor .fa.fa-text-height:before,
.note-popover .fa.fa-text-height:before {
  content: "\f182";
}
.note-editor .fa.fa-table:before,
.note-popover .fa.fa-table:before {
  content: "\f21e";
}
.note-editor .fa.fa-link:before,
.note-popover .fa.fa-link:before {
  content: "\f10d";
}
.note-editor .fa.fa-picture-o:before,
.note-popover .fa.fa-picture-o:before {
  content: "\f224";
}
.note-editor .fa.fa-minus:before,
.note-popover .fa.fa-minus:before {
  content: "\f16e";
}
.note-editor .fa.fa-arrows-alt:before,
.note-popover .fa.fa-arrows-alt:before {
  content: "\f29f";
}
.note-editor .fa.fa-code:before,
.note-popover .fa.fa-code:before {
  content: "\f066";
}
.note-editor .fa.fa-question:before,
.note-popover .fa.fa-question:before {
  content: "\f033";
}
.note-editor .fa.fa-eraser:before,
.note-popover .fa.fa-eraser:before {
  content: "\f17b";
}
.note-editor .fa.fa-square:before,
.note-popover .fa.fa-square:before {
  content: "\f1f4";
}
.note-editor .fa.fa-circle-o:before,
.note-popover .fa.fa-circle-o:before {
  content: "\f2e3";
}
.note-editor .fa.fa-times:before,
.note-popover .fa.fa-times:before {
  content: "\f29a";
}
.note-editor .note-air-popover .arrow,
.note-popover .note-air-popover .arrow {
  left: 20px;
}
.note-editor .note-editable {
  padding: 20px 23px;
}
.fileinput {
  position: relative;
  padding-right: 35px;
}
.fileinput .close {
  position: absolute;
  top: 5px;
  font-size: 12px;
  float: none;
  opacity: 1;
  font-weight: 500;
  border: 1px solid #ccc;
  width: 19px;
  text-align: center;
  height: 19px;
  line-height: 15px;
  border-radius: 50%;
  right: 0;
}
.fileinput .close:hover {
  background: #eee;
}
.fileinput .btn-file > input {
  z-index: 1000;
}
.fileinput .input-group-addon {
  padding: 0 10px;
  vertical-align: middle;
}
.fileinput .fileinput-preview {
  width: 200px;
  height: 150px;
  position: relative;
}
.fileinput .fileinput-preview img {
  display: inline-block;
  vertical-align: middle;
  margin-top: -13px;
}
.fileinput .fileinput-preview:after {
  content: "";
  display: inline-block;
  vertical-align: middle;
}
#lg-slider:after {
  content: "";
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  height: 50px;
  width: 50px;
  border-radius: 100%;
  border: 2px solid #2196f3;
  -webkit-animation: ball-scale-ripple 1s 0 infinite cubic-bezier(0.21, 0.53, 0.56, 0.8);
  animation: ball-scale-ripple 1s 0 infinite cubic-bezier(0.21, 0.53, 0.56, 0.8);
  position: absolute;
  left: 50%;
  margin-left: -25px;
  top: 50%;
  margin-top: -25px;
  z-index: -1;
}
#lg-outer {
  background: rgba(255, 255, 255, 0.95);
}
#lg-outer .object {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.16), 0 2px 10px rgba(0, 0, 0, 0.12);
  border-radius: 2px;
}
#lg-close {
  display: none;
}
#lg-action {
  top: 0;
  width: 100%;
  left: 0;
  margin-left: 0 !important;
  height: 40px;
  text-align: center;
}
#lg-action > a {
  background: transparent;
  color: #9D9D9D;
  font-size: 18px;
  width: 28px;
  height: 37px;
}
#lg-action > a:hover {
  background: transparent;
  color: #000;
}
#lg-action .cl-thumb {
  position: fixed;
  right: 20px;
  bottom: 20px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  line-height: 38px;
  background: #f44336;
  transition: all;
  transition-duration: 300ms;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.16), 0 2px 10px rgba(0, 0, 0, 0.12);
}
#lg-action .cl-thumb:after {
  text-align: center;
  left: 16px !important;
  bottom: 6px !important;
  color: #fff;
}
#lg-action .cl-thumb:hover {
  background: #f32c1e;
}
#lg-gallery .thumb-cont {
  background: #f44336;
  text-align: center;
}
#lg-gallery .thumb-cont .thumb-info {
  background: #f44336;
}
#lg-gallery .thumb-cont .thumb-info .count {
  display: none;
}
#lg-gallery .thumb-cont .thumb-info .close {
  width: 14px;
  margin-top: 0;
  background: none;
}
#lg-gallery .thumb-cont .thumb-info .close:hover {
  background: none;
}
#lg-gallery .thumb-cont .thumb {
  opacity: 1;
  filter: alpha(opacity=100);
}
#lg-gallery .thumb-cont .thumb-inner {
  display: inline-block;
  padding: 12px 12px 15px;
}
.lg-slide {
  background: none !important;
}
.lg-slide em {
  font-style: normal;
}
.lg-slide em h3 {
  margin-bottom: 5px;
}
.lg-slide .video-cont {
  box-shadow: 0 8px 17px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.19);
}
@-webkit-keyframes ball-scale-ripple {
  0% {
    -webkit-transform: scale(0.1);
    transform: scale(0.1);
    opacity: 1;
  }
  70% {
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 0.7;
  }
  100% {
    opacity: 0;
  }
}
@keyframes ball-scale-ripple {
  0% {
    -webkit-transform: scale(0.1);
    transform: scale(0.1);
    opacity: 1;
  }
  70% {
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 0.7;
  }
  100% {
    opacity: 0;
  }
}
.waves-button,
.waves-circle {
  -webkit-mask-image: none;
  line-height: inherit;
}
.date-picker .dp-inline {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.16), 0 2px 10px rgba(0, 0, 0, 0.12);
  display: inline-block;
}
.date-picker:not(.dp-blue):not(.dp-red) .tr-dpnav th {
  background: #009688;
}
.date-picker:not(.dp-blue):not(.dp-red) .tr-dpday th {
  background: #00877a;
}
.date-picker:not(.dp-blue):not(.dp-red) .dp-active {
  background-color: #009688;
}
.date-picker:not(.dp-blue):not(.dp-red) .dp-actions .btn-link {
  color: #009688;
}
.date-picker .dropdown-menu {
  padding: 0;
  margin: 0;
}
.date-picker.is-opened .dropdown-menu {
  -webkit-transform: scale(1);
  transform: scale(1);
  opacity: 1;
  filter: alpha(opacity=100);
}
.dp-table {
  position: relative;
  z-index: 1;
}
.dp-table thead > tr th:first-child {
  padding-left: 15px;
}
.dp-table thead > tr th:last-child {
  padding-right: 15px;
}
.dp-table tbody > tr:first-child > td {
  padding-top: 15px;
}
.dp-table tbody > tr:last-child > td {
  padding-bottom: 15px;
}
.dp-table tbody > tr td:first-child {
  padding-left: 15px;
}
.dp-table tbody > tr td:last-child {
  padding-right: 15px;
}
.btn-dp {
  background: transparent;
  border: 0;
}
.btn-dp .zmdi {
  font-size: 18px;
  line-height: 100%;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  line-height: 34px;
}
.btn-dp .zmdi:hover {
  background-color: rgba(0, 0, 0, 0.14);
}
.btn-dp[disabled] {
  color: #CDCDCD;
}
.btn-dp[disabled] .dp-day-muted {
  color: #CDCDCD;
}
.btn-dpbody {
  padding: 13px;
  font-size: 12px;
  border-radius: 2px;
}
.btn-dpbody:not(.dp-active):not([disabled]) {
  color: #000;
}
.btn-dpbody:not(.dp-active):not([disabled]):not(.dp-today):hover {
  background: #F0F0F0;
}
.btn-dpday {
  border-radius: 50%;
  width: 42px !important;
  height: 42px;
}
.tr-dpnav .btn-dp {
  color: #fff;
  padding: 25px 0 23px;
}
.tr-dpday th {
  padding: 8px 0 9px;
  color: #fff;
  text-transform: uppercase;
}
.dp-active {
  color: #fff;
}
.dp-today:not(.dp-active) {
  background-color: #E2E2E2;
}
.dp-day-muted {
  color: #8B8B8B;
}
.dp-title {
  font-weight: 400;
  font-size: 16px;
  text-transform: uppercase;
}
.dp-title:hover {
  background-color: rgba(0, 0, 0, 0.14);
  border-radius: 2px;
}
.dp-blue .tr-dpnav th {
  background: #2196f3;
}
.dp-blue .tr-dpday th {
  background: #128ff2;
}
.dp-blue .dp-active {
  background-color: #2196f3;
}
.dp-blue .dp-actions .btn-link {
  color: #2196f3;
}
.dp-red .tr-dpnav th {
  background: #f44336;
}
.dp-red .tr-dpday th {
  background: #f33527;
}
.dp-red .dp-active {
  background-color: #f44336;
}
.dp-red .dp-actions .btn-link {
  color: #f44336;
}
.dp-actions {
  padding: 10px 20px 20px;
  text-align: right;
}
.dp-actions .btn-link {
  text-decoration: none;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 500;
}
.ng-table th.sortable {
  cursor: pointer;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.ng-table th.sortable:hover {
  background-color: #FDFBD3;
}
.ng-table .form-control {
  border: 1px solid #E4E4E4;
  padding: 10px 15px;
  height: 40px;
}
.ng-table .form-control:active,
.ng-table .form-control:focus {
  border-color: #D7D7D7 !important;
}
.ng-table-pager {
  padding: 12px 25px 15px;
  min-height: 101px;
}
@media screen and (min-width: 768px) {
  .ng-table-pager {
    background: #f9f9f9;
  }
}
.ng-table-counts {
  box-shadow: none !important;
  margin-top: 23px;
  border: 1px solid #E8E8E8;
}
@media screen and (max-width: 768px) {
  .ng-table-counts {
    display: none;
  }
}
.ng-table-counts .active {
  background: #F0F0F0;
}
@media screen and (max-width: 768px) {
  .ng-table-pagination {
    width: 100%;
    text-align: center;
  }
}
.ng-table-pagination > li {
  position: relative;
}
.ng-table-pagination > li:first-child:before,
.ng-table-pagination > li:last-child:before {
  font-family: "Material-Design-Iconic-Font";
  font-size: 22px;
  position: absolute;
  left: 16px;
  top: 5px;
  z-index: 12;
}
.ng-table-pagination > li:first-child > a,
.ng-table-pagination > li:last-child > a {
  font-size: 0;
}
.ng-table-pagination > li:first-child:before {
  content: "\f2fa";
}
.ng-table-pagination > li:last-child:before {
  content: "\f2fb";
}
.sortable .ng-table-header {
  position: relative;
}
.sortable .ng-table-header:before {
  font-family: "Material-Design-Iconic-Font";
  position: absolute;
  right: 0;
  top: -2px;
  font-size: 17px;
}
.sortable.sort-desc .ng-table-header:before {
  content: "\f1ce";
}
.sortable.sort-asc .ng-table-header:before {
  content: "\f1cd";
}
.timepicker-picker .btn {
  box-shadow: none !important;
}
.timepicker-picker table tbody tr + tr:not(:last-child) {
  background: #009688;
  color: #fff;
}
.timepicker-picker table tbody tr + tr:not(:last-child) td {
  border-radius: 0;
}
.timepicker-picker .btn {
  background: #fff;
  color: #333;
}
.datepicker.top {
  -webkit-transform-origin: 0 100% !important;
  transform-origin: 0 100% !important;
}
.datepicker table thead tr th {
  border-radius: 0;
  color: #fff;
}
.datepicker table thead tr th .glyphicon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  line-height: 29px;
}
.datepicker table thead tr th:hover .glyphicon {
  background: rgba(0, 0, 0, 0.2);
}
.datepicker table thead tr:first-child th {
  background: #009688;
  padding: 20px 0;
}
.datepicker table thead tr:first-child th:hover {
  background: #009688;
}
.datepicker table thead tr:first-child th.picker-switch {
  font-size: 16px;
  font-weight: 400;
  text-transform: uppercase;
}
.datepicker table thead tr:last-child th {
  text-transform: uppercase;
  font-weight: 400;
  font-size: 11px;
}
.datepicker table thead tr:last-child th:first-child {
  padding-left: 20px;
}
.datepicker table thead tr:last-child th:last-child {
  padding-right: 20px;
}
.datepicker table thead tr:last-child:not(:only-child) {
  background: #00877a;
}
.datepicker table tbody tr:last-child td {
  padding-bottom: 25px;
}
.datepicker table tbody tr td:first-child {
  padding-left: 13px;
}
.datepicker table tbody tr td:last-child {
  padding-right: 13px;
}
.datepicker table td.day {
  width: 35px;
  height: 35px;
  line-height: 20px;
  color: #333;
  position: relative;
  padding: 0;
  background: transparent;
}
.datepicker table td.day:hover {
  background: none;
}
.datepicker table td.day:before {
  content: "";
  width: 35px;
  height: 35px;
  border-radius: 50%;
  margin-bottom: -33px;
  display: inline-block;
  background: transparent;
  position: static;
  text-shadow: none;
}
.datepicker table td.day.old,
.datepicker table td.day.new {
  color: #CDCDCD;
}
.datepicker table td:not(.today):not(.active):hover:before {
  background: #F0F0F0;
}
.datepicker table td.today {
  color: #333;
}
.datepicker table td.today:before {
  background-color: #E2E2E2;
}
.datepicker table td.active {
  color: #fff;
}
.datepicker table td.active:before {
  background-color: #009688;
}
.datepicker-months .month,
.datepicker-years .year,
.timepicker-minutes .minute,
.timepicker-hours .hour {
  border-radius: 50%;
}
.datepicker-months .month:not(.active):hover,
.datepicker-years .year:not(.active):hover,
.timepicker-minutes .minute:not(.active):hover,
.timepicker-hours .hour:not(.active):hover {
  background: #F0F0F0;
}
.datepicker-months .month.active,
.datepicker-years .year.active,
.timepicker-minutes .minute.active,
.timepicker-hours .hour.active {
  background: #009688;
}
.timepicker-minutes .minute,
.timepicker-hours .hour {
  padding: 0;
}
.checkbox > small {
  margin-top: 20px;
}
.m-l--5 {
  margin-left: -5px !important;
}
.tooltip {
  opacity: 1 !important;
}
.m-l-8 {
  margin-left: 8px !important;
}
.f-s {
  font-size: 23px !important;
}
@media (max-width: 360px) {
  #InOrder {
    float: left !important;
    margin-top: 10px;
  }
  #buttoncard {
    height: 98px !important;
  }
  #mobilecard {
    height: 390px !important;
  }
}
.product-grid__description {
  font-weight: bold;
  line-height: 1.2;
  margin-bottom: 0;
  margin-top: 4px;
  overflow: hidden;
  color: #5e5e5e;
  font-size: 16px;
}
.headmin-height {
  min-height: 170px;
}
.p-l-28 {
  padding-left: 28px !important;
}
.p-l-35 {
  padding-left: 35px !important;
}
.f-bold {
  font-weight: 700;
}
.m-auto {
  margin: auto;
}
.f-s-18 {
  font-size: 18px;
}
.bottom-btn {
  bottom: 15px;
  position: fixed;
  right: 15px;
  z-index: 20;
}
.f-s-14 {
  font-size: 14px;
}
.f-s-16 {
  font-size: 16px;
}
.f-s-20 {
  font-size: 20px;
}
.f-s-24 {
  font-size: 24px !important;
}
@media (max-width: 1199px) {
  #user {
    margin-bottom: 20px !important;
  }
}
.m-l-23 {
  margin-left: 23px !important;
}
@media (max-width: 1199px) {
  #autoshipdiv {
    padding-right: 0px !important;
  }
}
.btn {
  text-transform: uppercase !important;
  width: auto;
}
#__lpform_input_idx_0_numspan,
.__lpform_input_idx_0 {
  display: none !important;
}
.methoddropdown {
  width: 100%;
  background-color: transparent;
  color: #000000;
  text-align: left;
  padding: 6px 12px 0;
  box-shadow: none !important;
  background: rgba(0, 0, 0, 0) none repeat scroll 0 0;
  border-color: currentcolor currentcolor var(--color1);
  border-style: none none solid;
  border-width: medium medium 2px;
}
.dropper {
  display: block;
  float: left;
  width: 88%;
}
.dropper_menu {
  width: 100%;
  padding-left: 3px;
}
.second_menu {
  padding-left: 18px;
  color: rgb(153, 153, 153);
  font-size: 14px;
}
.caret_arrow {
  float: right;
  font-size: 22px;
  text-align: center;
  width: 8%;
}
.caret_arrow i {
  color: #00c1d6;
}
.dropdown-menu.dropper_menu > li:hover {
  cursor: grab;
}
.col-height {
  height: 330px;
}
.ds-cart__page-container {
  min-height: 600px;
}
.iosDevice .modal-open {
  overflow: unset;
}
.iosDevice .modal {
  overflow-y: scroll;
  position: relative;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  -webkit-overflow-scrolling: touch;
  outline: 0;
}
.iosDevice .modal.fade .modal-dialog {
  z-index: 99999;
  -webkit-transform: translate(0, -25%);
  -ms-transform: translate(0, -25%);
  transform: translate(0, -25%);
  -webkit-transition: -webkit-transform 0.3s ease-out;
  -moz-transition: -moz-transform 0.3s ease-out;
  -o-transition: -o-transform 0.3s ease-out;
  transition: transform 0.3s ease-out;
}
.iosDevice .modal.in .modal-dialog {
  -webkit-transform: translate(0, 0);
  -ms-transform: translate(0, 0);
  transform: translate(0, 0);
}
.iosDevice .modal-dialog {
  position: relative;
  width: auto;
  margin: 10px;
}
.iosDevice .modal-content {
  position: relative;
  background-color: #fff;
  border: 1px solid #999;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  -webkit-box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
  box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
  background-clip: padding-box;
  outline: 0;
}
.iosDevice .modal-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1040;
  background-color: #000;
}
.iosDevice .modal-backdrop.fade {
  filter: alpha(opacity=0);
}
.iosDevice .modal-backdrop.in {
  filter: alpha(opacity=50);
}
.iosDevice .modal-header {
  padding: 15px;
  border-bottom: 1px solid #e5e5e5;
  min-height: 16.42857143px;
}
.iosDevice .modal-header .close {
  margin-top: -2px;
}
.iosDevice .modal-title {
  margin: 0;
  line-height: 1.42857143;
}
.iosDevice .modal-body {
  position: relative;
  padding: 20px;
}
.iosDevice .modal-footer {
  margin-top: 15px;
  padding: 19px 20px 20px;
  text-align: right;
  border-top: 1px solid #e5e5e5;
}
.iosDevice .modal-footer .btn + .btn {
  margin-left: 5px;
  margin-bottom: 0;
}
.iosDevice .modal-footer .btn-group .btn + .btn {
  margin-left: -1px;
}
.iosDevice .modal-footer .btn-block + .btn-block {
  margin-left: 0;
}
@media (max-width: 420px) {
  .cart_mobile {
    margin-left: -30% !important;
    margin-top: -8% !important;
  }
  .cart_mobile .zmdi-shopping-cart {
    font-size: 21px !important;
  }
  .cart_mobile .cart-counter {
    width: 14px !important;
    height: 14px !important;
  }
  .menu_list {
    opacity: 1 !important;
    z-index: 9999 !important;
  }
  .ds-product-detail__body .img-box {
    width: 100% !important;
  }
  .ds-product-detail__body .share_box {
    text-align: left !important;
    margin-bottom: 2% !important;
  }
  .ds-product-detail__options__option {
    width: 100%;
  }
  .iosDevice .modal-backdrop {
    opacity: 0.5;
  }
}
@media (min-width: 768px) {
  .iosDevice .modal-dialog {
    width: 600px;
    margin: 30px auto;
  }
  .iosDevice .modal-content {
    -webkit-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
  }
  .iosDevice .modal-sm {
    width: 300px;
  }
}
@media (min-width: 992px) {
  .iosDevice .modal-lg {
    width: 900px;
  }
}
.flex-justify-end {
  justify-content: flex-end;
}
.rotate-90 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0.5);
  -webkit-transform: rotate(-90deg);
  -moz-transform: rotate(-90deg);
  -ms-transform: rotate(-90deg);
  -o-transform: rotate(-90deg);
  transform: rotate(-90deg);
}
#product_update_card .ds-cart__image-wrapper {
  position: relative;
  border-bottom: 1px solid #d3d3d3;
}
#product_update_card .ds-cart__image-wrapper__sales {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  border-top: 79px solid #1c7bbf;
  border-top: 79px solid var(--color1);
  border-bottom: 79px solid transparent;
  border-right: 79px solid transparent;
}
#product_update_card .ds-cart__image-wrapper__sales p {
  position: absolute;
  top: -60px;
  width: 79px;
  left: -15px;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  display: block;
}
#product_update_card .ds-cart__image-wrapper .btn {
  position: absolute;
  height: 32px;
  bottom: 10px;
  border-radius: 2px;
  box-shadow: none;
}
#product_update_card .ds-cart__image-wrapper .zmdi-share-btn {
  left: 15px;
  width: 42px;
}
#product_update_card .ds-cart__image-wrapper .more_colors {
  right: 15px;
  width: 108px;
  font-size: 12px;
  font-weight: 400;
}
#product_update_card .ds-cart__image-wrapper .opacity_btn {
  opacity: 0.8;
}
#product_update_card .ds-cart__image-wrapper .ds-cart__image img {
  height: 306px;
  width: 306px;
}
#product_update_card .ds-cart-size {
  height: 394px !important;
  width: 306px !important;
  box-shadow: none;
}
#product_update_card .ds-cart__item-meta .product-name {
  font-size: 16px;
  font-weight: 500;
  padding: 5px 0px 0px 0px;
}
#product_update_card .ds-cart__item-meta span {
  font-size: 14px;
}
#product_update_card .ds-cart__item-meta .product-color {
  color: #1c7bbf;
  color: var(--color1);
  text-align: left;
  width: 100%;
  font-weight: bold;
  padding: 0px 15px;
}
#product_update_card .ds-cart__item-meta .strikethrough {
  text-decoration: line-through;
  display: inline-block;
}
#product_update_card .ds-cart__item-meta .darkgray {
  color: darkgray;
}
#product_update_card .ds-cart__item-meta .zmdi-cart-plus-btn {
  border-radius: 5px;
  border: 2px solid rgba(165, 165, 165, 0.6901960784);
  box-shadow: none;
  color: rgba(165, 165, 165, 0.6901960784);
  font-weight: bold;
  padding: 5px 12px;
}
.mwo {
  max-width: 1340px !important;
}
.product-color {
  color: #1c7bbf;
  color: var(--color1);
  text-align: left;
  width: 100%;
  font-weight: bold;
  padding: 0px 15px;
}
.m-b-4 {
  margin-bottom: 4%;
}
.md-dropdown {
  position: relative;
}
.md-dropdown button {
  padding-right: 20px;
}
.md-dropdown .zmdi {
  position: absolute;
  right: 5px;
  top: 10px;
  display: inline-block;
  pointer-events: none;
}
#OrderView .selected_tab {
  border-bottom: 4px solid #4a4a4a !important;
  border-bottom: 2px solid #4a4a4a !important;
}
#OrderView .selected_tab > a {
  color: black !important;
}
#OrderView .tab-nav:not(.tn-vertical) {
  box-shadow: none !important;
}
#OrderView .tab-nav > li > a {
  font-weight: normal !important;
  text-transform: none !important;
  padding: 13px 13px 1px 13px !important;
}
.ds-container {
  max-width: 1304px;
  margin: 0 auto;
  padding-top: 40px !important;
  margin-top: 40px !important;
}
.md-tab {
  text-transform: inherit !important;
}
md-tabs.md-default-theme md-tabs-wrapper,
md-tabs md-tabs-wrapper {
  background-color: #edecec;
  border-color: rgba(0, 0, 0, 0);
}
md-tabs .md-tab.md-active {
  color: rgb(93, 94, 99);
}
.md-subheader.md-default-theme {
  background-color: white;
  font-size: 15px !important;
}
.md-subheader {
  background-color: #f6f6f6;
  font-size: 15px !important;
}
md-tabs.md-default-theme md-ink-bar,
md-tabs md-ink-bar {
  background: #5d5e63;
}
.sort-dropdown {
  top: 92%;
  right: 1%;
  padding-bottom: 15px !important;
}
.m-t--15 {
  margin-top: -15px;
}
html,
body {
  background: #edecec !important;
}
.sort-dropdown md-select {
  padding: 10px 2px 10px !important;
}
ordercartmodal md-backdrop {
  height: auto !important;
  position: fixed;
}
.f-right {
  float: right;
}
.margin-0 {
  margin: 0px !important;
}
.line_height_1 {
  line-height: 1.2em !important;
}
.bg-white {
  background-color: white;
}
.padding-0 {
  padding: 0px !important;
}
.ds-summary-cart md-toolbar md-list md-list-item .md-list-item-text h3 {
  font-weight: normal !important;
}
.c-light {
  color: rgba(0, 0, 0, 0.37);
}
.main_heading {
  font-size: 22px !important;
  margin-bottom: 0 !important;
}
.subheading_text {
  font-size: 12px !important;
}
p.main_price {
  font-size: 16px !important;
}
.main_qv {
  font-size: 12px;
}
h3.enroll_main_text {
  font-size: 15px !important;
}
p.enroll_main_total {
  font-size: 12px !important;
  font-weight: bold !important;
}
p.price_each {
  font-size: 15px !important;
}
p.f-right.qv_each {
  font-size: 12px !important;
  margin: 0 !important;
  font-weight: bold !important;
}
.product_detail_text {
  font-size: 15px !important;
  margin: 0 !important;
  line-height: 18px !important;
}
.product_detail_qv {
  font-size: 12px !important;
  overflow: auto;
}
.price_set p {
  margin-top: 26% !important;
  margin-left: -40% !important;
}
.total_block {
  padding: 2%;
  padding-right: 15px !important;
  font-size: 14px;
}
.top_0 {
  top: 0 !important;
}
.pad-right {
  padding-right: 4% !important;
}
body.modal-open .modal-body {
  overflow: auto !important;
}
md-datepicker input {
  pointer-events: none;
}
.f-small {
  font-size: small !important;
}
.md-3-line.m-t-5 {
  margin-top: 5% !important;
}
.ds-cart__page .ds-checkbox + .help-block {
  margin-bottom: 0;
  position: relative;
  clear: both;
}
.width-100 {
  min-width: 100px !important;
}
.header-bg-color {
  background-color: #F0F0F0;
}
.ratings {
  position: relative;
  vertical-align: middle;
  display: inline-block;
  color: #b1b1b1;
  overflow: hidden;
}
.full-stars {
  position: absolute;
  left: 0;
  top: 0;
  white-space: nowrap;
  overflow: hidden;
  color: #fde16d;
}
.empty-stars:before,
.full-stars:before {
  content: "\2605\2605\2605\2605\2605";
  font-size: 14pt;
}
.empty-stars:before {
  -webkit-text-stroke: 1px #848484;
}
.full-stars:before {
  -webkit-text-stroke: 1px orange;
}
@-moz-document url-prefix() {
  .full-stars {
    color: #ECBE24;
  }
}
.full-stars {
  color: #ECBE24;
}
.c-red {
  color: #C6161D;
}
.full-width {
  width: 100%;
}
.full-height {
  height: 100%;
}
.carousel-inner > .item > img {
  width: 100%;
  height: 730px;
}
@media (min-width: 768px) and (max-width: 960px) {
  .carousel-inner > .item > img {
    height: 366px !important;
  }
}
@media (min-width: 500px) and (max-width: 767px) {
  .carousel-inner > .item > img {
    height: 250px !important;
  }
}
@media (min-width: 320px) and (max-width: 499px) {
  .carousel-inner > .item > img {
    height: 200px !important;
  }
}
.item > img {
  border: none !important;
}
.w-49 {
  width: 49%;
}
.m-r-2 {
  margin-right: 2%;
}
.m-t-2 {
  margin-top: 2%;
}
.m-b-2 {
  margin-bottom: 2%;
}
#zpimage-zoomContainer {
  z-index: 1 !important;
}
.md-button.disabled,
.md-button[disabled],
fieldset[disabled] .md-button {
  cursor: not-allowed;
  opacity: 0.65;
  filter: alpha(opacity=65);
  -webkit-box-shadow: none;
  box-shadow: none;
}
a.md-button.disabled,
fieldset[disabled] a.md-button {
  pointer-events: none;
}
.md-button.disabled,
.md-button[disabled],
fieldset[disabled] .md-button {
  cursor: not-allowed !important;
  opacity: 0.65;
  filter: alpha(opacity=65);
  -webkit-box-shadow: none;
  box-shadow: none;
}
a.md-button.disabled,
fieldset[disabled] a.md-button {
  pointer-events: none;
}
.btn-disabled {
  cursor: not-allowed;
  opacity: 0.65;
  filter: alpha(opacity=65);
  -webkit-box-shadow: none;
  box-shadow: none;
}
.page-wrap {
  min-height: "calc(100vh - 260px)";
}
@media (max-width: 600px) {
  .product_detail_text {
    font-size: 13px !important;
    margin: 0 !important;
    line-height: 15px !important;
    padding-bottom: 5px;
  }
  .product_detail_qv.m-b-20 {
    margin-bottom: 4px !important;
  }
}
@media (max-width: 320px) {
  .ds-summary-cart md-content md-list-item.items {
    padding-left: 14px !important;
  }
}
.quantity_disable.disabled {
  background-color: hsl(0, 0%, 60%) !important;
}
#loading-bar .bar {
  height: 5px;
  background: #51c1E8;
}
#loading-bar .peg {
  box-shadow: #fff 1px 0 6px 1px;
}
#loading-bar-spinner {
  width: 56px;
  height: 56px;
  text-align: center;
  padding: 14px;
  border-radius: 50%;
  position: fixed;
  top: 105px;
  left: 50%;
  margin-left: -28px;
  background: #fff;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.16), 0 2px 10px rgba(0, 0, 0, 0.12);
  z-index: 9;
}
#loading-bar-spinner .spinner-icon {
  width: 28px;
  height: 28px;
  margin: 0;
  background: transparent !important;
  border: 2px solid rgb(81, 193, 232);
  border-bottom-color: transparent !important;
  border-radius: 100%;
  animation: loading-bar-spinner 0.75s linear infinite;
}
.sweet-alert {
  border-radius: 2px;
  padding: 10px 30px;
}
.sweet-alert h2 {
  font-size: 16px;
  font-weight: 400;
  position: relative;
  z-index: 1;
}
.sweet-alert .lead {
  font-size: 13px;
}
.sweet-alert .btn {
  padding: 6px 12px;
  font-size: 13px;
  margin: 20px 2px 0;
}
.sweet-alert .form-group {
  display: none;
}
.sweet-alert .sa-confirm-button-container {
  display: inline-block;
  position: relative;
}
.text-nonecase {
  text-transform: none !important;
}
.text_overflow {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.opacity-87 {
  opacity: 0.87 !important;
}
.opacity-54 {
  opacity: 0.54 !important;
}
.opacity-38 {
  opacity: 0.38 !important;
}
.ds-product-custom {
  border: none;
  margin: 7px 8px;
}
.c-1 {
  color: rgba(0, 0, 0, 0.8705882353);
}
/*# sourceMappingURL=sidebar-summary-cart.component.css.map */
